import * as React from "react";
import { createRoot } from "react-dom/client";

import { ContextProvider } from "./Context";
import { Portfolio } from "./Portfolio";
import { Loader } from "./components/Loader";

export function PortfolioWrapper() {
  return (
    <div>
      <ContextProvider>
        <Loader />
        <Portfolio />
      </ContextProvider>
    </div>
  );
}

export function start() {
  const container = document.getElementById("portfolio");
  if (container) {
    const root = createRoot(container);
    root.render(<PortfolioWrapper />);
  }
}
